module.exports = __webpack_public_path__ + "img/20220411_140154.25b6d21c.jpg";